// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"b0db20b3","70":"e46bb81c","477":"f72052ff","573":"20a42366","582":"fe04a7cc","741":"0b52c7c1","787":"64650b83"}[chunkId] + ".chunk.js";
};